import React, { type FC } from 'react'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Checkbox } from 'mailup-web-components'

import {
  isRecipientSelected,
  isSelectRecipientDisabled,
} from 'Pages/RecipientsList/recoil/state/results'

import { toggleSelectRecipientCallback } from 'Pages/RecipientsList/recoil/callbacks/bulk'

interface ItemSelectProps {
  id: number
}

const ItemSelect: FC<ItemSelectProps> = ({ id }) => {
  const checked = useRecoilValue(isRecipientSelected(id))
  const disabled = useRecoilValue(isSelectRecipientDisabled)

  const toggleSelectRecipient = useRecoilCallback(
    toggleSelectRecipientCallback,
    [],
  )

  const handleChange = (): void => {
    void toggleSelectRecipient(id)
  }

  return (
    <Checkbox
      value={id}
      checked={checked}
      disabled={disabled}
      onChange={handleChange}
      data-mu-test="select-recipient"
    />
  )
}

export default ItemSelect
